<template>
  <el-container>
    <el-header class="myheader"
      ><h6 class="mt-3">{{ granuleid }}</h6></el-header
    >
    <el-main
      ><div class="mapcontainer fullheight">
        <el-row>
          <el-col :span="14">
            <div id="scenemap" class="mymap"></div>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="8">
            <div class="infoboard">
              <el-table
                ref="mytable"
                height="75vh"
                :data="filteredProperty"
                style="width: 100%"
                :row-key="
                  (row) => {
                    return row.name;
                  }
                "
              >
                <el-table-column
                  prop="title"
                  :label="$t('downloadmessage.propertyname')"
                  sortable
                  width="200"
                />
                <el-table-column
                  prop="value"
                  :label="$t('downloadmessage.propertyvalue')"
                  width="300"
                >
                </el-table-column>
              </el-table>
            </div>

            <div class="mt-3">
              <el-row justify="end">
                <el-col :span="1"></el-col>
                <el-col :span="8">
                  <img
                    class="myimg"
                    style="width: 36px"
                    src="../assets/icons8-close-67.png"
                    href="#"
                    @click="onclosedownloadpage"
                    :title="$t('downloadmessage.closemess')"
                  />

                  <img
                    class="myimg mx-3"
                    style="width: 36px"
                    src="../assets/download-64.png"
                    href="#"
                    @click="ondownload"
                    :title="$t('downloadmessage.downloadmess')"
                  />
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-main>
  </el-container>
</template>

<script type="text/javascript">
import Map from "ol/Map";
import View from "ol/View";
import TileLayer from "ol/layer/Tile";
//import OSM from "ol/source/OSM";
import XYZ from "ol/source/XYZ";
import LayerPopup from "ol-ext/control/LayerPopup";
import { FullScreen } from "ol/control";
import * as olProj from "ol/proj";
import { ElMessageBox } from "element-plus";
import Zoomify from "ol/source/Zoomify";
import {
  ref,
  onMounted,
  onUnmounted,
  reactive,
  toRefs,
  computed,
  getCurrentInstance,
} from "vue";

import { getimginfo, getmeta } from "../js/querydata";
import { downloadfile } from "../js/util";
import { useI18n } from "vue-i18n";
export default {
  setup(props, { emit }) {
    const granuleid = ref("");
    const { t } = useI18n();
    const app = getCurrentInstance();
    const state = reactive({
      property: [
        {
          name: "Date",
          value: " 2022-04-05T10:00:31.024Z",
        },
      ],
      namelist: ["test"],
    });
    const { proxy } = getCurrentInstance();
    const datasource = ref("gaode");
    const mapcomponents = {
      currentdataid: "",
      osmlayer: {},
      baseimglayer: {},
      vectorlayer: {},
      map: {},
      scenelayer: {},
      resolution: 2,
      zoomlevel: 10,
      currentscenefilter: {},
      center: olProj.fromLonLat([37.5, 8.82]),
    };

     // 使用 computed 属性来过滤掉 'offline_flag'
    const filteredProperty = computed(() => {
      return state.property.filter(item => item.name !== 'offline_flag');
    });

    onMounted(() => {
      granuleid.value =
        "S2B_MSIL1C_20220331T100029_N0400_R122_T33TVH_20220331T121506";
      console.log(t);
      if (app.appContext.config.globalProperties.basemapfrom == "tdt")
        datasource.value = "tdt";
      else datasource.value = "gaode";

      initmap();
      setInterval(function () {
        mapcomponents.map.updateSize();
      }, 500);
      //console.log(proxy);
      proxy.$EventBus.on("showscene", onshowscene); //通过注册showscene 初始化数据信息
    });

    onUnmounted(() => {
      proxy.$EventBus.off("showscene");
      //不销毁下次显示不正常
      var v = mapcomponents.map.getViewport();
      v.parentNode.removeChild(v);
      console.log("remove viewport");
    });

    function initmap() {
      var vectorlayer, imglayer;
      var basevecurl, baseimgurl; //分别是天地图矢量、注记连接
      if (app.appContext.config.globalProperties.mapservtype === "offline") {
        basevecurl = "tdtmirror?servername=tdt&T=vec_w&x={x}&y={y}&l={z}";
        baseimgurl = "tdtmirror?servername=tdt&T=img_w&x={x}&y={y}&l={z}";
      } else {
        if (datasource.value == "tdt") {
          basevecurl =
            "https://t{0-7}.tianditu.gov.cn/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=25e7ad1ded22ea7e97142e7990f0c63f";
          baseimgurl =
            "https://t{0-7}.tianditu.gov.cn/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=25e7ad1ded22ea7e97142e7990f0c63f";
        } else {
          baseimgurl =
            "https://webst0{1-4}.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}&scl=1&lang=en"; //高德
          basevecurl =
            "https://webst0{1-4}.is.autonavi.com/appmaptile?style=7&x={x}&y={y}&z={z}&scl=1&lang=en"; //高德
        }
      }
      vectorlayer = new TileLayer({
        title: "World Administrative Divisions",
        baseLayer: true,
        // source: new OSM(),
        //对外发布只能用天地图的数据
        source: new XYZ({
          url: basevecurl,
        }),
        projection: "EPSG:3857",
        preload: Infinity,
        visible: false,
      });
      imglayer = new TileLayer({
        title: "Satellite Imagery",
        baseLayer: true,
        source: new XYZ({
          url: baseimgurl,
        }),
        projection: "EPSG:3857",
        visible: true,
      });
      if (datasource.value == "gaode") {
        imglayer.setVisible(false);
        vectorlayer.setVisible(true);
      }
      mapcomponents.baseimglayer = imglayer;
      let tarobj, view;

      tarobj = "scenemap";
      view = new View({
        center: olProj.fromLonLat([116.5, 39.82]),
        projection: "EPSG:3857",
        zoom: 4,
      });

      mapcomponents.vectorlayer = vectorlayer;

      mapcomponents.map = new Map({
        target: tarobj,
        controls: [
          new LayerPopup(),
          new FullScreen({ tipLabel: "full screen" }),
        ],
        layers: [vectorlayer, imglayer],
        view: view,
      });
    }
    const onshowscene = (dataid) => {
      //显示某一个景数据
      console.log("收到消息显示景" + dataid);
      granuleid.value = dataid;
      getimginfo(dataid).then((res) => {
        if (res.status == 200) {
          mapcomponents.scenelayer = genzoomifylayer(dataid, res.data); //生成zoomifylayer图层
          updatemap();
        }
      });
      getmeta(dataid).then((res) => {
        if (res.status == 200) {
          for (var i = 0; i < res.data.property.length; i++) {
            res.data.property[i].title = t(
              "downloadmessage." + res.data.property[i].name
            );
          }
          state.property = res.data.property;
        }
      });
    };
    //下载数据
    const ondownload = () => {
      for (let i = 0; i < state.property.length; i++) {
        if (
          state.property[i].name == "offline" &&
          state.property[i].value == "1"
        ) {
          ElMessageBox.alert("Product Offline");
          return;
        }
      }
      downloadfile(granuleid.value);
    };

    //生成景图层
    const genzoomifylayer = (dataid, data) => {
      var left, right, bottom, top, imgWidth, imgHeight, zoomifyUrl, zoomproj;

      left = data.left;
      right = data.right;
      top = data.top;
      bottom = data.bottom;

      imgWidth = data.imgwidth * data.resolution;
      imgHeight = data.imgheight * data.resolution;
      var extent = [left, bottom, right, top];

      zoomifyUrl =
        "fetchscene?dataid=" +
        dataid +
        "&cmdtype=getzoomify" +
        "&x={x}&y={y}&z={z}&tileIndex={tileIndex}" +
        "&imgwidth=" +
        data.imgwidth +
        "&imgheight=" +
        data.imgheight;

      zoomproj = new olProj.Projection({
        code: "EPSG:3857",
        units: "m",
        extent: extent,
      });

      var zoomisource = new Zoomify({
        url: zoomifyUrl,
        size: [imgWidth, imgHeight],
        tileSize: 512,
        extent: extent,
        projection: zoomproj,

        imageSmoothing: true,
        zDirection: -1, // Ensure we get a tile with the screen resolution or higher
      });

      let zoomilayer = new TileLayer({
        title: "product",
        preload: Infinity,
        maxTilesLoading: 200,
        source: zoomisource,
        className: "stamen", //必须加才能正常进行掩板
        visible: true,
      });
      mapcomponents.resolution = data.resolution;
      mapcomponents.zoomlevel = 15 - Math.log2(imgWidth / 4000);

      mapcomponents.center = [(right + left) / 2, (bottom + top) / 2];

      return zoomilayer;
    };
    const onclosedownloadpage = () => {
      emit("onclosedownloadpage");
    };
    function updatemap() {
      //清除所有已有的图层
      mapcomponents.map.getLayers().forEach(function (layer) {
        mapcomponents.map.removeLayer(layer);
      });
      var viewdata = {
        center: mapcomponents.center,
        zoom: mapcomponents.zoomlevel,
        minResolution: mapcomponents.resolution / 4,
        projection: "EPSG:3857",
      };
      var nview = new View(viewdata);
      var layers = [];

      layers.push(mapcomponents.vectorlayer);
      layers.push(mapcomponents.baseimglayer);
      if (!isobjempty(mapcomponents.scenelayer))
        layers.push(mapcomponents.scenelayer);

      mapcomponents.map.setLayers(layers);

      mapcomponents.map.setView(nview);
    }
    function isobjempty(myobj) {
      if (Object.getOwnPropertyNames(myobj).length === 0) return true;
      //返回false，为空对象
      return false;
      //返回true，不为空对象
    }
    return { granuleid, ondownload, onclosedownloadpage, ...toRefs(state),filteredProperty };
  },
};
</script>

<style scoped>
.myimg {
  cursor: pointer;
}

.myheader {
  background: rgb(76, 79, 87);
  color: white;
  text-align: center;
}
.mymap {
  height: 80vh;
  border: 2px solid rgb(113, 109, 109);
}
.infoboard {
  height: 75vh;
  /* border: 1px solid blue; */
}

.metaval {
  /* 元数据值样式 */
  color: rgb(7, 65, 127);
  font-family: "Courier New", Courier, monospace;
  font-size: small;
}
/* 老挝语字体 */
.lwfont {
  font-family: "Saysettha OT", sans-serif;
}

/* 英语字体 */
.enfont {
  font-family: "Arial", sans-serif;
}
</style>
